const ForgetPassword = () => {
  return (
    <>
      <p>forgotPassword</p>
    </>
  );
};

export default ForgetPassword;
